import { call, put, takeLatest, all, cancelled } from "redux-saga/effects"
import { orderBy, find, map, filter, isEmpty, flatMap, sum } from "lodash"
import { push } from "connected-react-router"
import axios from "axios"
import { message } from "antd"

import {
  GET_MEASURE_SIMPLE_WATCHER,
  UPDATE_MEASURE_WATCHER,
  REPROCESS_MEASURE_WATCHER
} from "./constants"

import {

  getMeasureSimpleSuccess,
  getMeasureSimpleFailed,
  updateMeasureSuccess,
  updateMeasureFailed,
  reprocessMeasureSuccess,
  reprocessMeasureFailed
} from "./actions"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 10000000000)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}



function getMeasureSimpleApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${params.idMeasure}/detailSimple`
  })
}

export function* getMeasureSimpleSaga(action) {
  try {
    const { data: response } = yield call(getMeasureSimpleApi, action.payload)

    yield put(getMeasureSimpleSuccess(response.data))
  } catch (e) {
    yield call(messageFailed, 'La medición no existe en el sistema.')
    yield put(getMeasureSimpleFailed())
  }
}

function updateMeasureApi(params) {
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/update/deofficialize`,
    params
  })
}

export function* updateMeasureSaga(action) {
  try {
    const  data = yield call(updateMeasureApi, action.payload)
    yield call(messageSuccess, data.data.msj)
    yield put(updateMeasureSuccess())
  } catch (e) {
    yield call(messageFailed, 'La medición no existe en el sistema.')
    yield put(updateMeasureFailed())
  }
}
function reprocessMeasureApi(params) {
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/reprocess`,
    params
  })
}

export function* reprocessMeasureSaga(action) {
  try {
    const  data = yield call(reprocessMeasureApi, action.payload)
    yield call(messageSuccess, data.data.msj)
    yield put(reprocessMeasureSuccess())
  } catch (e) {
    yield call(messageFailed, 'No se pudo reprocesar')
    yield put(reprocessMeasureFailed())
  }
}
// Individual exports for testing
export default function* measurementDetailSimpleSaga() {
  yield takeLatest(GET_MEASURE_SIMPLE_WATCHER, getMeasureSimpleSaga)
  yield takeLatest(UPDATE_MEASURE_WATCHER, updateMeasureSaga)
  yield takeLatest(REPROCESS_MEASURE_WATCHER, reprocessMeasureSaga)
}
